import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { useDispatch } from "react-redux";

import { IUserInfo } from "../interfaces";
import { storeUserInfoAction } from "../redux/actions";
import ApiHandler from "../common/api";

export const useUserRoles = () => {
    const [request, setRequest] = useState(false);
    const [review, setReview] = useState(false);
    const [audit, setAudit] = useState(false);
    const [isInitialized, setIsInitialized] = useState(false);

    const dispatch = useDispatch();
    const { accounts } = useMsal();

    function createAccountMap(roles: string[]) {
        const accountMap = new Map();
        let hasRequestRole = false;
        let hasReviewRole = false;
        let hasAuditRole = false;

        for (const role of roles) {
            if (role === "BreakGlass.Reviewer") {
                hasReviewRole = true;
                ApiHandler.reviewer = true;
            } else if (role === "BreakGlass.Auditor") {
                hasAuditRole = true;
                ApiHandler.auditor = true;
            } else if (role === "BreakGlass.Admin") {
                hasReviewRole = true;
                ApiHandler.reviewer = true;
                hasAuditRole = true;
                ApiHandler.auditor = true;
            } else {
                const words = role.split(".");
                const account = words[2];
                const awsrole = words[1];

                if (accountMap.has(account)) {
                    accountMap.get(account).push(awsrole);
                } else {
                    const awsroles: Array<string> = [];

                    awsroles.push(awsrole);
                    accountMap.set(account, awsroles);
                }
                hasRequestRole = true;
                ApiHandler.requester = true;
            }
        }

        setRequest(hasRequestRole);
        setReview(hasReviewRole);
        setAudit(hasAuditRole);

        return accountMap;
    }

    const [accountMap, setAccountMap] = useState(new Map());

    const initializeUserInfo = () => {
        if (!accounts || accounts.length === 0) {
            return;
        }

        const map = createAccountMap(accounts[0]?.idTokenClaims?.roles ? accounts[0]?.idTokenClaims?.roles : []);

        setAccountMap(map);
        setIsInitialized(true);
    };

    useEffect(() => {
        if (accounts && accounts.length > 0 && !isInitialized) {
            initializeUserInfo();
        }
    }, [accounts, isInitialized]);

    useEffect(() => {
        if (isInitialized && accounts && accounts.length > 0) {
            const userInfo: IUserInfo = {
                user: accounts[0]?.username ? accounts[0]?.username : "",
                requester: request,
                reviewer: review,
                auditor: audit,
                accountMap: accountMap,
            };

            dispatch(storeUserInfoAction(userInfo));
        }
    }, [isInitialized, request, review, audit, accountMap, accounts, dispatch]);

    return {
        request,
        review,
        audit,
        isInitialized,
    };
};
